import { render, staticRenderFns } from "./AddNewIntentModal.vue?vue&type=template&id=7d067cef&"
import script from "./AddNewIntentModal.vue?vue&type=script&lang=js&"
export * from "./AddNewIntentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports